var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMypageDoctor = function SvgMypageDoctor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    d: "M18.89 12.821v2.87a4.19 4.19 0 0 1-4.183 4.184 4.185 4.185 0 0 1-4.177-4.069c3.08-.614 5.407-3.337 5.407-6.595V3.47h-2.624V9.21a4.106 4.106 0 0 1-4.102 4.101 4.106 4.106 0 0 1-4.102-4.1V3.468H2.484V9.21c0 3.262 2.335 5.987 5.42 6.596.064 3.701 3.088 6.693 6.803 6.693a6.816 6.816 0 0 0 6.809-6.809v-2.87z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD267",
    fillRule: "evenodd",
    d: "M6.094 3.797a2.297 2.297 0 1 1-4.595 0 2.297 2.297 0 0 1 4.595 0M22.5 12.328a2.297 2.297 0 1 1-4.595 0 2.297 2.297 0 0 1 4.595 0m-7.875-6.234a2.297 2.297 0 1 0 0-4.595 2.297 2.297 0 0 0 0 4.595",
    clipRule: "evenodd"
  })));
};
export default SvgMypageDoctor;